import { render, staticRenderFns } from "./guardian.vue?vue&type=template&id=2318ec47&scoped=true"
import script from "./guardian.vue?vue&type=script&lang=js"
export * from "./guardian.vue?vue&type=script&lang=js"
import style0 from "./guardian.vue?vue&type=style&index=0&id=2318ec47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2318ec47",
  null
  
)

export default component.exports